"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTruthyKeys = exports.swapKeysAndValues = void 0;
const swapKeysAndValues = (obj) => {
    const swapped = {};
    for (const key in obj) {
        const val = obj[key];
        swapped[val] = key;
    }
    return swapped;
};
exports.swapKeysAndValues = swapKeysAndValues;
const getTruthyKeys = (obj) => {
    return Object.entries(obj).reduce((agg, [key, val]) => {
        if (val) {
            agg.push(key);
        }
        return agg;
    }, []);
};
exports.getTruthyKeys = getTruthyKeys;
//# sourceMappingURL=object.js.map